import {ActionTree, GetterTree, Module, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import {Agreement, AgreementFilter, AgreementState, HarmonizedSystemType} from "@/modules/agreement/types";
import {getAgreement, getAgreements, getAgreementGroups, getAgreementGroup} from "@/services/agreement";

export const state: AgreementState = {
  agreement: {
    id: "",
    name: "",
    valid_to: "",
    valid_from: "",
    de_minimis_percentage: "",
    harmonized_system_type: null,
  },
  agreements: [],
  filter: {
    id_agreement_group: undefined,
    offset: 0,
    limit: 0
  }
}

const actions: ActionTree<AgreementState, RootState> = {
  async GET_AGREEMENT(_, id) {
    return await getAgreement(id);
  },
  async GET_AGREEMENTS(_, payload) {
    return await getAgreements(payload);
  },
  async GET_AGREEMENT_GROUPS() {
    return await getAgreementGroups();
  },
  async GET_AGREEMENT_GROUP(_, id) {
    return await getAgreementGroup(id);
  },
}

const mutations: MutationTree<AgreementState> = {
  SET_AGREEMENT(state, agreement: Agreement) {
    state.agreement = agreement;
  },
  SET_AGREEMENTS(state, agreements: Agreement[]) {
    state.agreements = agreements;
  },
  SET_AGREEMENT_FILTER(state, filter: AgreementFilter | undefined) {
    state.filter = filter;
  }
}

const getters: GetterTree<AgreementState, RootState> = {
  AGREEMENT(state): Agreement {
    const {agreement} = state;
    return {...agreement};
  },
  AGREEMENTS(state): Agreement[] {
    const {agreements} = state;
    return [...agreements];
  },
  AGREEMENT_FILTER(state): AgreementFilter | undefined {
    return state.filter;
  }
}

export const agreement: Module<AgreementState, RootState> = {
  state,
  actions,
  getters,
  mutations
}
